import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TapestrySpinnerModule } from '@predictiveindex/tapestry';
import { TranslationsModule } from '../translations';
import { PatternInsightsComponent } from './pattern-insights.component';

@NgModule({
    declarations: [PatternInsightsComponent],
    imports: [CommonModule, TapestrySpinnerModule, TranslationsModule],
    exports: [PatternInsightsComponent]
})
export class PatternInsightsModule {}
